export default {
    comparisonOptions: {
        leftType: "contextProperty",
        leftValue: "itemId",
        rightType: "constantValue",
        rightValue: "",
        operator: "equals",
        id: 0
    },
    conditionState: true,
    type: "comparison",
    operator: "equals"
}